import n from "./component-library4.js";
import i from "./component-library3.js";
/* empty css                     */
import o from "./component-library98.js";
const a = {
  name: "CompactItemInfo",
  components: { LinkButton: i, Arrow: n },
  props: {
    name: { type: String, required: !0 },
    activeVariants: { type: Array, required: !0 },
    position: { type: Number, required: !0 },
    isConfigurable: Boolean,
    isExtended: Boolean
  },
  emits: ["open-bundle-item-config"],
  computed: {
    actionLabel() {
      return this.isExtended ? "schließen" : "anpassen";
    }
  }
};
var s = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "compact-item-info" }, [e("div", { staticClass: "content" }, [e("div", { staticClass: "primary-text text--bold" }, [t._v(" " + t._s(t.name) + " ")]), e("div", { staticClass: "secondary-text" }, [t._v(" " + t._s(t.activeVariants.join(", ")) + " ")])]), t.isConfigurable ? e("LinkButton", { staticClass: "action", attrs: { tag: "button", text: "" }, on: { click: function(p) {
    return t.$emit("open-bundle-item-config", { position: t.position });
  } } }, [t._v(" " + t._s(t.actionLabel) + " "), e("Arrow", { staticClass: "action__icon", attrs: { tag: "span", direction: t.isExtended ? "top" : "bottom" } })], 1) : t._e()], 1);
}, r = [], c = /* @__PURE__ */ o(
  a,
  s,
  r,
  !1,
  null,
  "2c37f802"
);
const f = c.exports;
export {
  f as default
};
